<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'c-col',
  props: {
    sizeMobile: {
      type: String,
      default: '12',
    },
    sizeTablet: {
      type: String,
      default: '6',
    },
    sizeDesktop: {
      type: String,
      default: '6',
    },
    horizontalAlign: {
      type: String,
      default: 'center',
    },
    verticalAlign: {
      type: String,
      default: 'top',
    },
    bgColor: {
      type: String,
      default: 'transparent',
    },
    experience: {
      type: Boolean,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    borderColor: {
      type: String,
      default: '#074E8E',
    },
    borderWidth: {
      type: String,
      default: '1px'
    },
    borderRadius: {
      type: String,
      default: '5px'
    },
    gapMobile: {
      type: String,
      default: '',
      validator: (value) => ['', 'small', 'medium', 'large'].includes(value),
    },
    gapTablet: {
      type: String,
      default: '',
      validator: (value) => ['', 'small', 'medium', 'large'].includes(value),
    },
    gapDesktop: {
      type: String,
      default: '',
      validator: (value) => ['', 'small', 'medium', 'large'].includes(value),
    },
  },
  computed: {
    classes() {
      return [
        'col',
        `col-${this.sizeMobile}`,
        `col-md-${this.sizeTablet}`,
        `col-lg-${this.sizeDesktop}`,
        `col--h-${this.horizontalAlign}`,
        `col--v-${this.verticalAlign}`,
        { 'col--experience': this.experience },
        { 'col--b-has-border': this.hasBorder },
        this.gapMobile ? `c-gap-mobile-${this.gapMobile}` : '',
        this.gapTablet ? `c-gap-tablet-${this.gapTablet}` : '',
        this.gapDesktop ? `c-gap-desktop-${this.gapDesktop}` : '',
      ]
    },
    styles() {
      return {
        'background-color': this.bgColor,
        'border-color': this.hasBorder ? this.borderColor : '',
        'border-width': this.hasBorder ? this.borderWidth : '',
        'border-radius': this.hasBorder ? this.borderRadius : ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.col {
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;

  &--h-fill {
    align-items: stretch;
  }

  &--h-left {
    align-items: flex-start;
  }

  &--h-center {
    align-items: center;
  }

  &--h-right {
    align-items: flex-end;
  }

  &--v-fill {
    justify-content: stretch;

    &>* {
      flex-grow: 1;
    }
  }

  &--v-top {
    justify-content: flex-start;
  }

  &--v-center {
    justify-content: center;
  }

  &--v-bottom {
    justify-content: flex-end;
  }

  &--experience {
    padding-top: 30px;
    border: 1px solid purple;

    &::before {
      content: '[ - col - ]';
      position: absolute;
      top: 0;
      font-size: 12px;
    }
  }

  &--no-padding-right {
    padding-right: 0;
  }

  &--no-padding-left {
    padding-left: 0;
  }

  &--no-padding-top {
    padding-top: 0;
  }

  &--no-padding-bottom {
    padding-bottom: 0;
  }

  &--b-has-border {
    border: solid 1px #074E8E;
  }
}
</style>
